var a={loadingBtn:"loadingBtn__n3LLRa","spin-animation":"spin-animation__RgesP2","ball-beat-animation":"ball-beat-animation__s7xrk0","hide-scroll-animation":"hide-scroll-animation__69DX3m"};export{a as default};
